import Restaurantform from "../../../components/Resturent_form";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  useGetFoodItemByIdQuery,
  useUpdateFoodItemMutation,
  useGetShopCategoriesQuery,
  useLazyGetShopCategoriesQuery,
} from "../../../features/shop/shopApiSlice";
import { useSelector } from "react-redux";
import { SuccessNotify, FailedNotify } from "../../../constants/tostify";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import { publishImage } from "../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
const ResturentUpdateform = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [displayimg, setDisplayimg] = useState();
  const { name } = useSelector((state) => state.user);
  const [isloading, setIsloading] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [data, setData] = useState({
    category: "",
  });
  const [mygetitem, setMygetitem] = useState();

  useEffect(() => {
    setMygetitem(localStorage.getItem("mycategory"));
  }, []);

  const Handledata = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const categoryName = data?.category[1];
  const categoryid = data?.category[0];

  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setUpdatedata((updatedata) => ({
        ...updatedata,
        images: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });
  const [updatedata, setUpdatedata] = useState({
    userid: name?._id,
    shopid: "",
    dishname: "",
    category: categoryid,
    subCategory: "",
    price: "",
    preparationTime: "",
    country: "",
    city: "",
    state: "",
    contact: "",
    email: "",
    salesPromotion: "",
    specialOffers: "",
    currency: "",
    duration: "",
    images: [""],
    status: true,
  });
  const { data: foodItemData } = useGetFoodItemByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (foodItemData?.data) {
      const fetchedData = foodItemData.data;
      setUpdatedata({
        ...fetchedData,
        shopid: fetchedData.shopid?._id || fetchedData.shopid,
      });
      setDisplayimg(fetchedData?.images);
    }
  }, [foodItemData]);

  useEffect(() => {
    setUpdatedata((updatedata) => ({
      ...updatedata,
      category: categoryid,
    }));
  }, [categoryid]);

  const { data: categoryData } = useGetShopCategoriesQuery({ type: "foodShop", parentCategory: "" });

  useEffect(() => {
    if (categoryData?.success) {
      setShopCategory(categoryData?.data?.Category);
    }
  }, [categoryData]);

  const [getShopCategoriesTwo] = useLazyGetShopCategoriesQuery();

  const Mydata = async () => {
    try {
      if (categoryName) {
        const response = await getShopCategoriesTwo({ type: "foodShopItem", parentCategory: categoryName }).unwrap();
        if (response?.success) {
          setShopCategorytwo(response?.data?.Category);
        }
      }
    } catch (error) {
      console.log("servicesCategories", error);
    }
  };

  const [updateFoodItem] = useUpdateFoodItemMutation();

  const updateDatahandler = async (e) => {
    setIsloading(true);
    e.preventDefault();
    try {
      const response = await updateFoodItem({ id, data: updatedata }).unwrap();
      if (response?.scuess || response?.success) {
        setIsloading(false);
        setTimeout(() => {
          SuccessNotify("Add Post Successfully");
        }, 1000);
        navigate(`/RestaurantAlldata/${response?.data?.foodItem?.shopid || updatedata?.shopid}`);
      }
    } catch (e) {
      setIsloading(false);
      FailedNotify("Failed To Post Try Again!");
    }
  };



  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }

  const handlevalue = (e) => {
    setUpdatedata((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <>
      <Restaurantform
        btntext="Update"
        updatedata={updatedata}
        id={id}
        handlevalue={handlevalue}
        updateDatahandler={updateDatahandler}
        Mydata={Mydata}
        shopCategory={shopCategory}
        shopCategorytwo={shopCategorytwo}
        Handledata={Handledata}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        isUploading={isUploading}
        uploadProgress={uploadProgress}
      />
    </>
  );
};

export default ResturentUpdateform;
